// extracted by mini-css-extract-plugin
module.exports = {"search-label":"searchLabel_search-label__370AC","search-label-main":"searchLabel_search-label-main__8MXd6","search-label-driver":"searchLabel_search-label-driver__1WQjA"};